<script lang="ts">
	interface Props {
		size?: 'sm' | 'lg';
	}
	let { size = 'sm' }: Props = $props();
</script>

<span class="spinner {size}" aria-hidden="true"></span>

<style lang="scss">
	.spinner {
		display: block;
		border-radius: 50%;
		animation: spin 0.7s linear infinite;

		&.sm {
			width: 0.75rem;
			height: 0.75rem;
			border: 1.5px solid var(--border-subtle);
			border-top-color: var(--text-secondary);
		}

		&.lg {
			width: 3rem;
			height: 3rem;
			border: 3px solid var(--border-subtle);
			border-top-color: var(--text-secondary);
		}
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>
